import { BOTH, INBOUND, OUTBOUND } from 'constants/booking';

const getDirection = (outbound, inbound, segments) => {
  const hasOutbound = outbound.some((o) => segments.includes(o.id));
  const hasInbound = inbound.some((i) => segments.includes(i.id));

  if (hasOutbound && hasInbound) {
    return BOTH;
  }
  if (hasOutbound) {
    return OUTBOUND;
  }

  return INBOUND;
};

export const formatExtras = (outbound, inbound, extras) =>
  extras.map((extra) => ({
    ...extra,
    direction: getDirection(outbound, inbound, extra.segments)
  }));

export const formatPassengers = (passengers) =>
  passengers.map((p) => ({
    id: p.id,
    type: p.type,
    disabilityType: p.disabilityType
  }));

export const formatSegments = (segments) =>
  segments.map((segment) => ({
    id: segment.id,
    direction: segment.direction,
    origin: segment.origin.uic,
    destination: segment.destination.uic,
    serviceName: segment.trainNumber,
    startValidityDate: segment.timing.date,
    startValidityTime: segment.timing.departs
  }));
